import { ProductHome as AkProductHome } from '@atlaskit/atlassian-navigation';
import { AtlassianLogo, AtlassianIcon } from '@atlaskit/logo';
import React from 'react';

export function ProductHome() {
  return (
    <AkProductHome
      testId="product-home"
      icon={() => <AtlassianIcon appearance="brand" />}
      logo={() => <AtlassianLogo appearance="brand" />}
      href="/"
    />
  );
}
